import React from "react";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";
import { useCms } from "../context/CmsContext";

const DEFAULTS = {
    s1_target: "Terminale & post-bac",
    s1_title: "Parcoursup",
    s1_desc: "Parcoursup est stressant, les délais sont courts et les formations sont nombreuses. Nous vous accompagnons pas à pas pour construire une candidature solide et cohérente.",
    s1_bullets: "Sélection et stratégie des vœux\nRédaction de la lettre de motivation\nCompréhension des attendus de chaque filière\nGestion des résultats et des listes d'attente",
    s2_target: "Collège, Lycée : 2de, 1re, Tle",
    s2_title: "Choix de filière",
    s2_desc: "Scolarité au collège, spécialités en première, orientation en terminale, grande école ou fac… ces choix peuvent sembler vertigineux. Nous vous aidons à les démystifier et à prendre les décisions qui vous correspondent.",
    s2_bullets: "Bilan de vos intérêts et points forts\nExploration des filières et débouchés\nChoix des spécialités de première et de terminale\nPrépa, BTS, IUT, licence, master…",
    s3_target: "Prépa, BTS, IUT, licence, master — Étudiants",
    s3_title: "Réorientation",
    s3_desc: "Vous êtes en fac, en BTS, en IUT, en école et vous réalisez que cette voie ne vous correspond pas ? Nous vous aidons à rebondir sans perdre de temps et de confiance en vous.",
    s3_bullets: "Compréhension des raisons\nIdentification de nouvelles pistes concrètes\nPasserelles et équivalences possibles\nReconstruction d'un projet motivant",
    s4_target: "Pour tous les profils",
    s4_title: "Accompagnement sur mesure",
    s4_desc: "Chaque jeune est différent. Certains ont besoin d'une seule séance pour affiner ses choix, d'autres d'un suivi sur plusieurs mois. Nous nous adaptons à votre rythme, votre situation, et à votre budget.",
    s4_bullets: "Séance unique ou suivi régulier\nEn présentiel ou en visio\nPremier échange de 30 min offert",
};

export default function Accompagnements() {
    const cms = useCms();
    const t = (k, fb) => cms.get(k, fb);
    const lines = (k, fb) => (t(k, fb) || "").split("\n").map((l) => l.trim()).filter(Boolean);

    const services = [1, 2, 3, 4].map((i) => ({
        n: `0${i}`,
        title: t(`acc.s${i}_title`, DEFAULTS[`s${i}_title`]),
        target: t(`acc.s${i}_target`, DEFAULTS[`s${i}_target`]),
        desc: t(`acc.s${i}_desc`, DEFAULTS[`s${i}_desc`]),
        bullets: lines(`acc.s${i}_bullets`, DEFAULTS[`s${i}_bullets`]),
    }));

    return (
        <div data-testid="page-accompagnements" className="bg-ink-800 min-h-screen text-white">
            <PublicNav />

            <section className="pt-24 pb-[42px] lg:pt-32 lg:pb-[42px] px-6 md:px-12">
                <div className="max-w-5xl mx-auto">
                    <span className="font-serif text-2xl sm:text-3xl text-ice block mb-3">Nos Accompagnements</span>
                    <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-2 leading-[1.1]">
                        Pour <span className="text-ice">chaque étape</span> de votre parcours.
                    </h1>
                    <p className="mt-6 text-lg text-white/80 leading-relaxed max-w-3xl whitespace-pre-line">
                        {t("acc.hero_subtitle", "Que vous soyez au collège, au lycée, en prépa, en fac ou perdu entre deux choix, nous avons un accompagnement fait pour vous.")}
                    </p>
                </div>
            </section>

            <section className="px-6 md:px-12 py-[42px] border-t border-white/5">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {services.map((s) => (
                        <article
                            key={s.n}
                            data-testid={`service-${s.n}`}
                            className="bg-ink-700 rounded-xl border border-ice/15 p-10 hover:border-ice/40 transition-colors"
                        >
                            <div className="flex items-baseline justify-between gap-4 flex-wrap">
                                <span className="font-serif text-6xl text-ice/70">{s.n}</span>
                                <span className="text-sm tracking-wide text-ice text-right max-w-[60%]">{s.target}</span>
                            </div>
                            <h3 className="font-serif text-3xl mt-4">{s.title}</h3>
                            <p className="mt-4 text-white/85 leading-relaxed text-base whitespace-pre-line">{s.desc}</p>
                            <ul className="mt-6 space-y-2.5">
                                {s.bullets.map((b, i) => (
                                    <li key={i} className="flex items-start gap-3 text-base text-white/85">
                                        <span className="mt-2.5 inline-block w-1.5 h-1.5 rounded-full bg-ice shrink-0" />
                                        {b}
                                    </li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>

            <Footer />
        </div>
    );
}
